import React from "react";
import {
  Card,
  TextField,
  TextDescription,
  Button,
  Icon,
  Typography,
  ButtonMenu,
} from "@ann/web-components";
import {
  CardContainer,
  FormContainer,
  ActionsContainer,
  SendToFieldContainer,
  FromEmailContainer,
  ButtonWrapper,
  IconWrapper,
} from "./SendEmailWithGet.styled";

const SendEmailWithGet = ({
  fromEmail,
  fromEmailOptions = [],
  onFromEmailChange,
  sendTo,
  onSendToChange,
  subject,
  onSubjectChange,
  body,
  onBodyChange,
  onCancel,
  onSend,
  onAIGenerate,
  onAttachFile,
  onInsertLink,
  onDelete,
  onCcClick,
}) => {
  const selectedFromEmail = fromEmailOptions.find(
    (opt) => opt.value === fromEmail
  );

  const handleFromEmailChange = (value) => {
    onFromEmailChange?.(value);
  };

  return (
    <CardContainer>
      <Card>
        <FormContainer>
          <FromEmailContainer>
            <Typography
              category="subtitle"
              weight="bold"
              size="small"
              color="subtitle"
            >
              From:
            </Typography>
            <ButtonMenu
              pill
              label={selectedFromEmail?.label || fromEmailOptions[0]?.label || "Select email"}
              size="small"
              type="secondary"
              menuPosition="bottom"
              onChange={handleFromEmailChange}
              width="auto"
            >
              <ButtonMenu.Menu>
                {fromEmailOptions.map((option) => (
                  <ButtonMenu.Item
                    key={option.value}
                    label={option.label}
                    value={option.value}
                  >
                    {option.label}
                  </ButtonMenu.Item>
                ))}
              </ButtonMenu.Menu>
            </ButtonMenu>
          </FromEmailContainer>
          <SendToFieldContainer>
            <TextField
              label="Send to"
              placeholder="Add the recipient's email."
              value={sendTo}
              onChange={onSendToChange}
              size="small"
            />
            <Typography
              category="subtitle"
              weight="bold"
              size="small"
              onClick={onCcClick}
            >
              Cc
            </Typography>
          </SendToFieldContainer>

          <TextField
            label="Subject"
            placeholder="Add a subject to your email"
            value={subject}
            onChange={onSubjectChange}
            size="small"
          />

          <TextDescription
            label="Body"
            placeholder="Start writing or ask AI to generate a draft..."
            value={body}
            onChange={onBodyChange}
            size="small"
          />
        </FormContainer>

        <ActionsContainer>
          <ButtonWrapper>
            <Button
              label="Cancel"
              type="secondary"
              size="small"
              onClick={onCancel}
            />
            <Button
              label="Send"
              type="primary"
              size="small"
              onClick={onSend}
            />
          </ButtonWrapper>
          <IconWrapper>
            <Icon
              name="aiChat"
              onClick={onAIGenerate}
              size="small"
              style={{ cursor: "pointer" }}
            />
            <Icon
              name="filePresent"
              onClick={onAttachFile}
              size="small"
              style={{ cursor: "pointer" }}
            />
            <Icon
              name="link"
              onClick={onInsertLink}
              size="small"
              style={{ cursor: "pointer" }}
            />
            <Icon
              name="delete"
              onClick={onDelete}
              size="small"
              style={{ cursor: "pointer" }}
            />
          </IconWrapper>
        </ActionsContainer>
      </Card>
    </CardContainer>
  );
};

export default SendEmailWithGet;
